// @ts-nocheck
import { canAddToCart } from "@store/Framework/Store/Store/Data/Products/ProductsSelectors"; // Store Custom Code
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

export const useCanAddToCart = convertSelectorToHook(canAddToCart);
